module.exports = __webpack_public_path__ + "static/front/img/hospital-cleaning.67d149d0.jpg";